import { resolveComponent as _resolveComponent, mergeProps as _mergeProps, createVNode as _createVNode, withCtx as _withCtx, openBlock as _openBlock, createBlock as _createBlock } from "vue"

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_a_select = _resolveComponent("a-select")!
  const _component_FormItem = _resolveComponent("FormItem")!

  return (_openBlock(), _createBlock(_component_FormItem, {
    label: _ctx.$attrs.label,
    name: _ctx.$attrs.name,
    value: _ctx.$attrs.value,
    rules: _ctx.$attrs.rules,
    extra: _ctx.$attrs.extra,
    help: _ctx.$attrs.help,
    class: "input-dropdown"
  }, {
    default: _withCtx(() => [
      _createVNode(_component_a_select, _mergeProps(_ctx.$attrs, {
        "show-search": _ctx.search,
        filterOption: _ctx.filterOption,
        "on-focus": _ctx.focusHandler,
        "on-blur": _ctx.blurHandler,
        onChange: _ctx.changeHandler,
        disabled: _ctx.isDisabled || _ctx.disabled,
        options: _ctx.options,
        mode: _ctx.mode
      }), null, 16, ["show-search", "filterOption", "on-focus", "on-blur", "onChange", "disabled", "options", "mode"])
    ]),
    _: 1
  }, 8, ["label", "name", "value", "rules", "extra", "help"]))
}